import React from 'react'
import { useTranslation } from 'react-i18next'

import DataTable from '../../../../../packages/kiti/components/table/DataTable'
import Text from '../../../../../packages/kiti/components/presentation/Text'
import { usePlaceStocks } from '../_load/PlaceStocksLoader'

const PlaceStocksTable = () => {
  const { t } = useTranslation('listStocks')
  const data = usePlaceStocks()

  const columns = [
    {
      label: t('placeStocks.table.place'),
      dataIndex: 'place',
      flex: 1,
      bold: true,
      render: data => <Text>{data.name}</Text>
    },

    {
      label: t('placeStocks.table.amount'),
      dataIndex: 'amount',
      flex: 1,
      render: data => <Text>{data}</Text>
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" />
}

export default PlaceStocksTable
